<script setup>
import { ref } from "vue";
import { EmptyPage } from "@components";

import { useSettings } from "@store/settings";
const $settings = useSettings();

const emptyPageContent = ref({
  heading: {
    title: "Select customizer",
    subtitle: "To edit click on the 'Booking Form' or 'Booking Chat Widget'",
  },
  buttonCta: [
    {
      title: "Booking Form",
      subtitle: "Edit booking form",
      icon: "star04",
      link: { name: "customizer.form" },
    },
    // {
    //   title: "Booking Chat Widget",
    //   subtitle: "Edit booking chat widget",
    //   icon: "star04",
    //   link: { name: "chat.customizer" },
    // },
  ],
});

if ($settings.addons.chat_widget) {
  emptyPageContent.value.buttonCta.push({
    title: "Booking Chat Widget",
    subtitle: "Edit booking chat widget",
    icon: "star04",
    link: { name: "customizer.chat" },
  });
}
</script>

<template>
  <EmptyPage :pageContent="emptyPageContent" />
</template>
